

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Slide, Carousel } from 'vue-carousel';

@Component({
  components: {
    Carousel,
    Slide,
  },
})
export default class Slider extends Vue {
  @Prop({ type: Array, required: true }) public slides!: object[];

  private currentSlide: number = 1;
  private totalSlides: number = 1;

  private updateSliderData(): void {
    this.totalSlides = this.slides.length;
  }

  private created(): void {
    this.updateSliderData();
  }

  private mounted(): void {
    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % (this.totalSlides);
    });
  }
}
